<div class="auc-card" [ngClass]="{ 'auc-card-list-view': showListView }">
  <div class="card-image-container">
    <img class="img-fluid auc-banner" alt="coverPhoto" AuctionDefaultImage *ngIf="data" [image]="data.coverPhoto"
      role="button" (click)="goToViewDetail(data.auctionCode)" />
    <img class="img-fluid auc-logo-list-view" alt="clientLogo" AuctionDefaultImage *ngIf="data"
      [image]="data.clientLogo" role="button" (click)="goToViewDetail(data.auctionCode)" />
  </div>

  <div class="home-card-logo">
    <img class="img-fluid" alt="clientLogo" AuctionDefaultImage *ngIf="data" [image]="data.clientLogo" role="button"
      (click)="goToViewDetail(data.auctionCode)" />
  </div>

  <div class="auc-card-content custom-data pb-0" [ngClass]="{ 'pb-0': !showListView }">
    <div class="badge-type">
      <span class="card-badge-colored">{{ data.saleTypePublicName }} </span>
    </div>

    <h3 class="auc-heading" role="button" (click)="goToViewDetail(data.auctionCode)">
      {{ data.title }}
    </h3>
    <p class="card-sub-text mb-21 min-height-110" [innerHTML]="data.tagline"></p>
    <p class="card-sub-text mt-2 mb-2" *ngIf="data.saleType.isDetailPageInHouse && data.locations">
      <img alt="Location" class="mr-2" src="assets/images/location-green.svg" />
      <strong>{{ data.locations }}</strong>
    </p>

    <ng-container *ngIf="!data.isSold; else isSold">
      <p class="auc-card-bold-text" [ngClass]="{ 'mb-0': showListView }" [innerHtml]="
          data?.saleType?.auctionDate
            | auctionDateFormat
              : data?.auctionStatus
              : data?.timeZoneName
              : data?.startDateTime
              : data?.endDateTime
              : data?.saleType?.dateText
        "></p>
    </ng-container>
    <ng-template #isSold>
      <p class="auc-card-bold-text" [ngClass]="{ 'mb-0': showListView }">
        Closing Began
        {{ data.lastEndDateTimeUtc | toLocalDateTime: true:data?.timeZoneName }}
      </p>
    </ng-template>

    <!-- this is for 'closing today' icon -->
    <span *ngIf="data.saleType.isDetailPageInHouse && isClosingToday" class="aucCardsBadge">
      Closing Today
    </span>

    <ng-container *ngIf="
        data.saleType.isDetailPageInHouse &&
        data.saleType.registrationFormat ===
          registrationFormats.thirdPartyRegistration &&
        (data.auctionStatus == auctionStatuses.live ||
          data.auctionStatus == auctionStatuses.upcoming)
      ">

    </ng-container>
  </div>

  <div class="auc-card-content auc-card-btns pt-0" [ngClass]="{ 'pb-0': showListView }">
    <!-- this is for sold entirely -->
    <div class="w-100 mb-2 sold-wrap text-left" *ngIf="data.isSold">
      <div class="badge-type">
        <span class="card-badge-colored mr-2">SOLD</span>
      </div>
      Sold In Its Entirety
    </div>

    <!-- this container is for detail paged auctions -->
    <ng-container *ngIf="data.saleType.isDetailPageInHouse; else redirectLinkButton">
      <!-- for lot catalog button -->
      <ng-container *ngIf="data.saleType.isCatalogUploadAllowed; else notAllowed">
        <ng-container *ngIf="
            ![auctionStatuses.past, auctionStatuses.archived].includes(
              data.auctionStatus
            )
          ">
          <div class="w-100">
            <button type="button" class="btn btn-white-border w-100 btnWithMarg btn-full"
              [ngClass]="{ 'mb-2': !showListView }" role="button" (click)="goToLots(data.auctionCode)">
              <span *ngIf="!isBiddingOpen; else biddingOpen">
                {{
                data.lotsCount
                ? "Lot Catalog Available"
                : "Lot Catalog Coming soon"
                }}
              </span>
              <ng-template #biddingOpen>
                {{ data.lotsCount ? "Bid Now" : "Lot Catalog Coming soon" }}
              </ng-template>
            </button>
          </div>
        </ng-container>
      </ng-container>

      <!-- for lot catalog not available button -->
      <ng-template #notAllowed>
        <div class="w-100">
          <a [href]="data.catalogLinkUrl" target="_blank" role="button" class="btn btn-white-border w-100 btnWithMarg"
            [ngClass]="{
              'mb-2': !showListView,
              'disabled-link': !data.catalogLinkUrl
            }" *ngIf="data.catalogLinkUrl">
            {{ getButtonText(data) }}
          </a>
        </div>
      </ng-template>
      <!-- this is for lot-configure button -->

      <div class="dFlexCards">
        <!-- this is for Register button (tbg-registrations) -->
        <ng-container *ngIf="
            data.saleType.registrationFormat ==
              registrationFormats.tbgRegistration &&
            !data.saleType.isCatalogReadOnly &&
            (data.auctionStatus === auctionStatuses.live ||
              data.auctionStatus === auctionStatuses.upcoming)
          ">
          <button type="button" class="btn btn-colored w-100 btnLSide" [ngClass]="{ 'mb-2': !showListView }" *ngIf="
              data.isRegistrationActive &&
              !data.loggedInUser &&
              !data.loggedInUser?.isRegistered
            " role="button" (click)="goToRegister(data.auctionCode)">
            Register
          </button>
          <button type="button" class="btn btn-white-border w-100 btnLSide" [ngClass]="{ 'mb-2': !showListView }" *ngIf="
              isLoggedIn == true &&
              data.loggedInUser?.isApproved &&
              data.loggedInUser?.isRegistered
            ">
            Approved
          </button>
          <button type="button" class="btn btn-white-border w-100 btnLSide" [ngClass]="{ 'mb-2': !showListView }" *ngIf="
              isLoggedIn == true &&
              !data.loggedInUser?.isApproved &&
              data.loggedInUser?.isRegistered
            ">
            Awaiting Approval
          </button>
        </ng-container>
        <!-- this is for Register button (3rd party registrations) -->
        <ng-container *ngIf="data.saleType.registrationFormat === registrationFormats.thirdPartyRegistration
          || data.registrationLinkUrl">
          <a role="button" class="btn btn-colored w-100 btnLSide btnWithMarg aHalf"
            [ngClass]="{ 'mb-2': !showListView }" *ngIf="data.registrationLinkUrl"
            [ngClass]="{ 'disabled-link': !data.registrationLinkUrl }" [href]="data.registrationLinkUrl"
            target="_blank">
            {{ isBiddingOpen ? "Register & Bid" : data.saleType.registrationFormat == 2 && data.saleType.isCatalogUploadAllowed ? "Register & Bid" : "Register" }}
          </a>
        </ng-container>
        <!-- this is for Register button (inquiry form) -->
        <ng-container *ngIf="
            data.saleType.registrationFormat === registrationFormats.inquiryForm
          ">
          <button type="button" class="btn btn-white-border w-100 btnLSide btnWithMarg"
            [ngClass]="{ 'mb-2': !showListView }" role="button" (click)="goToInquire(data.auctionCode)">
            Inquire Now
          </button>
        </ng-container>
        <!-- this is for View Details button -->
        <a type="button" [ngClass]="{ onlyOneView: !data.isRegistrationActive }"
          class="btn btn-colored btn-colored-grey w-100 btnRSide aHalf" role="button"
          [href]="goToViewDetailHref(data.auctionCode)">
          View Details
        </a>
      </div>
    </ng-container>
    <!-- this container is register button for redirect link wo detail page -->
    <ng-template #redirectLinkButton>
      <a role="button" class="btn btn-colored btn-colored-grey w-100 btnRSide onlyOneView"
        [href]="data.detailPageLinkUrl" [ngClass]="{ 'disabled-link': !data.detailPageLinkUrl }" target="_blank">
        View Details
      </a>
    </ng-template>
  </div>
</div>
